import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

export const visitCompletionReopenV1Schema = z.object({
  reopenId: entityIdSchema,
  completionId: entityIdSchema,
  completionVersion: z.number().int().positive(),
  visitId: entityIdSchema,
  visitVersion: z.number().int().positive(),
  planRecordVersion: z.number().int().positive(),
  billingReversalEntryId: entityIdSchema,
  reviewExceptionId: entityIdSchema,
  capturedAt: z.iso.datetime({ offset: true }),
}).strict()

export const visitCompletionReopenResultV1Schema = z.object({
  entityType: z.literal("completion_reopen"),
  entityId: entityIdSchema,
  state: z.enum(["Reopened", "Awaiting Review"]),
  version: z.literal(1),
  completionId: entityIdSchema,
  visitId: entityIdSchema,
  visitState: z.enum(["Scheduled", "Completed"]),
  directReopenApplied: z.boolean(),
  officeReviewRequired: z.boolean(),
  reviewExceptionId: entityIdSchema.nullable(),
  billingReversalEntryId: entityIdSchema.nullable(),
}).strict().refine(
  (result) =>
    result.directReopenApplied !== result.officeReviewRequired &&
    (result.directReopenApplied === (result.state === "Reopened")) &&
    (result.officeReviewRequired === (result.reviewExceptionId !== null)),
  { message: "Re-open result state is inconsistent." },
)

export type VisitCompletionReopenV1 = z.infer<
  typeof visitCompletionReopenV1Schema
>
export type VisitCompletionReopenResultV1 = z.infer<
  typeof visitCompletionReopenResultV1Schema
>
